export const checkCategorySelector = (value)=> {
    return (value === 0) ? false : true; 
}
export const checkNumberInput = (value) => {
    return (value < 0) ? false : true;
}
export const checkTextInput = (value)=> {
    return (value === null || value === "") ? false : true;
}
export const checkFileInput = (file) => {
    return (file === null || file === "") ? false : true;
}



// WEBPACK FOOTER //
// ./src/pages/Admin/ProductManager/Category/Product/InputValidation.js